import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';

@Component({
  selector: 'ap-content-page',
  templateUrl: './content-page.component.html'
})
export class ContentPageComponent implements OnInit, OnDestroy {

  context: any;
  contentInstance: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit() {
    this.activatedRoute.data
      .pipe(untilDestroyed(this))
      .subscribe((data) => {
        if (this.contentInstance != null && this.context != null
          && data.content.componentName === this.contentInstance.context.content.componentName) {
          this.contentInstance.context = data;
        }
        this.context = data;
        this.scrollContentToTop();
      }, err => {});

    fromEvent(window, 'message')
      .pipe(
        filter(p => (<any>p).origin === window.location.origin
                    && ((<any>p).data) != null
                    && (<any>p).data.action === 'link'),
        untilDestroyed(this)
      )
      .subscribe(p => {
        this.router.navigate([(<any>p).data.href]);
      });
  }

  ngOnDestroy(): void { }

  onActivated(instance: any): void {
    this.contentInstance = instance;

    if (instance == null) return;
    instance.context = this.context;
  }

  scrollContentToTop() : void {
    this.document.body.scrollIntoView();
  }
}
